import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor para agregar token en headers
api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// POST: Registrar stock de tejidos
const postStockTejidos = async (datos) => {
  try {
    const response = await api.post('registroTejido', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

// (Opcional) GET: Obtener registros de stock de tejidos si lo necesitas
const getStockTejidos = async () => {
  try {
    const response = await api.get('stockTejidos');
    return response.data;
  } catch (error) {
    console.error('Error al obtener stock tejidos:', error);
    throw error;
  }
};

export const getStockTejidoEspera = async () => {
  try {
    const response = await api.get(`registroTejido`);
    return response.data;
  } catch (error) {
    throw new Error("Error al obtener datos del backend:", error);
  }
};

export const getStockEvoluaco = async () => {
  try {
    const response = await api.get(`rollosEvoluaco`);
    return response.data;
  } catch (error) {
    throw new Error("Error al obtener datos del backend:", error);
  }
};

export const getStockTejidoStock = async () => {
  try {
    const response = await api.get(`registroTejidoStock`);
    return response.data;
  } catch (error) {
    throw new Error("Error al obtener datos del backend:", error);
  }
};

export const getStock2TejidoStock = async () => {
  try {
    const response = await api.get(`registroTejidoStock2`);
    return response.data;
  } catch (error) {
    throw new Error("Error al obtener datos del backend:", error);
  }
};

export const getOneStockTejido = async (serie) => {
  try {
    const response = await api.get(`obtenerTejidosSerie/${serie}`);
    return response.data;
  } catch (error) {
    throw new Error('Paquete no encontrado ', error);
  }
};

export const updateEstadoStockTejido = async (serie) => {
  try {
    const response = await api.put(`/actualizarestado/${serie}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al enviar datos al backend: ', error);
  }
};

export const updateEstadoSalida = async (serie, data) => {
  try {
    const response = await api.put(`/darsalida/${serie}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al enviar datos al backend: ', error);
  }
};

const getOne = async (serie) => {
  try {
    const response = await api.get(`getSerie/${serie}`);
    return response.data;
  } catch (error) {
    throw new Error('Paquete no encontrado ', error);
  }
};

export const getOne2 = async (serie) => {
  try {
    const response = await api.get(`getSerie2/${serie}`);
    return response.data;
  } catch (error) {
    throw new Error('Serie no encontrada ', error);
  }
};
export {
  postStockTejidos,
  getStockTejidos,
  getOne 
};
